import React from 'react';

import { DocumentTitle, PageHeader } from 'components/common';
import { Alert, Row, Col } from 'components/bootstrap';
import DataWarehouseBackendButton from 'data-warehouse/data-warehouse-backend-config/DataWarehouseBackendButton';
import DataWarehousePageNavigation from 'data-warehouse/components/DataWarehousePageNavigation';
import { LICENSE_SUBJECTS } from 'license/constants';
import LicenseCheck from 'license/LicenseCheck';
import { DATA_WAREHOUSE_LICENSE_TITLE, DATA_WAREHOUSE_LICENSE_TEXT } from 'data-warehouse/Constants';

import BackendConfigOverview from './BackendConfigOverview';

const DataWarehouseBackendPage = () => (
  <DocumentTitle title="Data Warehouse Backend Configurations">
    <DataWarehousePageNavigation />
    <PageHeader title="Data Warehouse Backend Configurations"
                actions={<DataWarehouseBackendButton />}>
      <span>
        Manage your configurations
      </span>
      <Alert bsStyle="info">
        Data Warehouse may use either an <b>S3 Bucket (recommended)</b> or <b>network storage</b> as a back end.<br />
        Note that only one Data Warehouse back-end may be configured at a time, and when changing back-end configuration, existing stored data will not be automatically moved to the new back end and will remain in the old one.<br />
        In this circumstance, data should be migrated between back-ends outside of the product.
      </Alert>
      <Alert bsStyle="warning">
        When using a filesystem - altering the permissions of files in the Data Warehouse  back-end can result in corruption of data.
      </Alert>
    </PageHeader>
    <LicenseCheck licenseSubject={LICENSE_SUBJECTS.archive}
                  title={DATA_WAREHOUSE_LICENSE_TITLE}
                  text={DATA_WAREHOUSE_LICENSE_TEXT}
                  displayWarningContainer
                  bsStyle="danger" />
    <Row className="content">
      <Col md={12}>
        <BackendConfigOverview />
      </Col>
    </Row>
  </DocumentTitle>
);

export default DataWarehouseBackendPage;
